import * as React from 'react';

import { StepActiveMilitaryPersonalInfoComponent } from './StepActiveMilitaryPersonalInfoComponent';

// Collect status is identical to Active at this time.
const StepCollectMilitaryStatusComponent = ({ verificationService }) =>
    (<StepActiveMilitaryPersonalInfoComponent verificationService={verificationService} />);

export { StepCollectMilitaryStatusComponent };
